import { memo } from "react";

const SKELETON_CARD_COUNT = 4;

/**
 * Loading skeleton for the Live Quran screen — mirrors the real layout (video
 * player + "More Videos" card grid) so there is no layout shift once data
 * arrives. Uses Bootstrap's `placeholder` utilities for the shimmer.
 */
const LiveQuranSkeleton = () => (
  <div className="placeholder-glow" role="status" aria-label="Loading">
    {/* Video player placeholder (matches the 600px iframe). */}
    <div>
      <span
        className="placeholder d-block w-100"
        style={{ height: 600, borderRadius: 10 }}
        aria-hidden="true"
      />
    </div>

    {/* "More Videos" heading + cards. */}
    <div className="container-xxl">
      <div className="row">
        <span
          className="placeholder mt-3"
          style={{ width: 140, height: 24, borderRadius: 6 }}
          aria-hidden="true"
        />
        {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="col-12 col-sm-6 col-md-4 my-3 col-lg-3"
          >
            <div className="card h-100 border-0 br-card">
              <span
                className="placeholder d-block w-100"
                style={{ aspectRatio: "16 / 9", borderRadius: 20 }}
                aria-hidden="true"
              />
              <div style={{ margin: 8 }}>
                <span
                  className="placeholder d-block col-9 mb-2"
                  style={{ height: 14, borderRadius: 4 }}
                  aria-hidden="true"
                />
                <span
                  className="placeholder d-block col-6"
                  style={{ height: 14, borderRadius: 4 }}
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

    <span className="visually-hidden">Loading…</span>
  </div>
);

export default memo(LiveQuranSkeleton);
